export default __webpack_public_path__ + "static/media/graphic-01.02605e48.png";